import * as React from "react";
import { useParams } from "react-router-dom";
import { BillingUsage } from "./billingUsage";
import { request } from "../../services/cpln";

type RouteParams = "id";
export const UsageOrgNamesProvider = () => {
  const { id } = useParams<RouteParams>();

  const [orgNames, setOrgNames] = React.useState<string[]>(null as any);

  React.useEffect(() => {
    fetchOrgNames();
  }, []);

  async function fetchOrgNames() {
    try {
      const { data } = await request({ service: "billing-ng", url: `/account/${id}/org` });
      setOrgNames(data.items.map((i) => i.name));
    } catch (e) {
      setOrgNames([]);
    }
  }

  if (!orgNames) {
    return null;
  }

  return <BillingUsage accountId={id!} orgNames={orgNames} />;
};
